import ItemType from "../../../../../enums/itemType.enum";
import ActionIcon from "../../../../ui/action-icon/ActionIcon";
import ItemCard from "../item-card/ItemCard";
import "./ItemList.scss";

interface IItemListProps {
  items: string[];
  title: string;
  onIncrement: (item: string) => void;
  onDecrement: (item: string) => void;
}

const ItemList = (props: IItemListProps) => {
  return (
    <div className="item-list">
      <table>
        <thead>
          <tr>
            <th>{props.title}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {props.items.length > 0 &&
            props.items.map((item, i) => {
              return (
                <tr key={i}>
                  <td>{item}</td>
                  <td className="action-column">
                    <ActionIcon
                      icon="fa-solid fa-square-plus"
                      onClick={() => props.onIncrement(item)}
                    />{" "}
                    /
                    <ActionIcon
                      icon="fa-solid fa-square-minus"
                      onClick={() => props.onDecrement(item)}
                    />
                  </td>
                </tr>
              );
            })}
          {props.items.length === 0 && (
            <tr>
              <td colSpan={4} className="centered">
                No items found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ItemList;
